import { render, staticRenderFns } from "./LazadaRedirect.vue?vue&type=template&id=a264dafa&"
import script from "./LazadaRedirect.vue?vue&type=script&lang=js&"
export * from "./LazadaRedirect.vue?vue&type=script&lang=js&"
import style0 from "./LazadaRedirect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports